<template>
  <div>
    <b-form novalidate @submit.prevent="onSubmit">
      <b-row>
        <b-col xs="12" md="6">
          <b-card class="mt-3">
            <h4 slot="header">Basic</h4>
            <text-control label="ID" v-model="item.id" disabled></text-control>
            <text-control label="Key" v-model="item.key"></text-control>
            <text-control label="Subscriber Title" v-model="item.subscriberTitle" required></text-control>
            <text-control label="Client Title" v-model="item.title" required></text-control>
            <text-control label="Default Weight" v-model="item.defaultWeight" :minValue="-100000" :maxValue="100000"></text-control>
            <checkbox-control label="Optional" v-model="item.isOptional"></checkbox-control>
          </b-card>
        </b-col>
        <b-col xs="12" md="6">
          <b-card class="mt-3">
            <h4 slot="header">Description</h4>
            <textarea-control label="Description" v-model="item.description"></textarea-control>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <v-jsoneditor v-model="item.questions" :options="jsonEditorOptions" height="80vh"></v-jsoneditor>
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col>
          <b-button-toolbar key-nav>
            <b-button-group>
              <b-button type="submit" variant="primary">
                <slot name="save"></slot>
              </b-button>
            </b-button-group>
            <b-button-group class="mx-2">
              <b-button type="button" @click="onCancel">Cancel</b-button>
            </b-button-group>
          </b-button-toolbar>
        </b-col>
      </b-row>
          
    </b-form>
  </div>
</template>

<script>
export default {
  name: "TemplateFields",
  props: [
      'item'
  ],
  data() {
    return {
      jsonEditorOptions: {
        limitDragging: true,
        mode: 'view',
        modes: [
          'view',
          'code'
        ],
        enableSort: false,
        enableTransform: false
      }
    };
  },
  methods: {
    onCancel(evt) {
      this.$emit('cancel');
    },
    onSubmit(evt) {
      // Make sure all the child components are valid
      if (this.$children.every(childComponent => { return typeof(childComponent.isValid) === 'undefined' || childComponent.isValid; }))
        this.$emit('submit');
    }
  }
};
</script>